<div [formGroup]="form" class="ovrrride-flange-input-wrap">
    <mat-label class="font-style" [ngbTooltip]="m_tooltip" placement="right" container="body" tooltipClass="custom-tooltip"> M </mat-label>
    <!--tool-tip template start-->
    <ng-template #m_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.M' | transloco }}
        </p>
    </ng-template>

    <div class="example-checkbox" [ngClass]="form.get('m').valid ? '' : 'highLight'">
        <div>
            <mat-checkbox class="example-margin checkbox-wrap" name="resultOptionEl" formControlName="ism"></mat-checkbox>
        </div>
        <mat-form-field class="example-full-width" [floatLabel]="'never'">
            <input
                matInput
                formControlName="m"
                name="m"
                type="number"
                #tooltip="matTooltip"
                matTooltip="Enter only digits"
                [matTooltipDisabled]="form.get('m').valid"
                placeholder=""
                [readonly]="!form.get('ism').value"
            />
        </mat-form-field>
    </div>
</div>
